var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white px-3 py-3 tw-rounded-md",class:_vm.cardClasses},[_c('p',{staticClass:"mb-0 tw-text-xs fs-md-16 text-center",class:_vm.textClasses},[_vm._v(" "+_vm._s(_vm.value == null ? "- " : _vm.value)+" "+_vm._s(_vm.end_value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }